import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { BjdItem, RegionsType } from '@/service/common/commonQueries';
import { customFetch } from '@/service/commonFetch';
import { useRegionStore } from '@/store/region';
import { appToSaveBjdCd } from '@/utils/js/webView';

export const useRegionSync = (bjdCd: string) => {
  const queryKey = ['regions', bjdCd];
  const { isHydrated } = useRegionStore();

  const query = useQuery({
    queryKey,
    queryFn: () =>
      customFetch<RegionsType>(`/regions`, {
        params: { bjdCd },
        next: {
          revalidate: false, // 영구 캐시
          tags: queryKey,
        },
      }),
    enabled: !!bjdCd && !!isHydrated,
    gcTime: Infinity,
    staleTime: Infinity,
  });

  useEffect(() => {
    // console.log(query.data);
    if (query.data) {
      handleRegionUpdate(query.data.data.regionsInfo);
    }
  }, [query.data]);

  return query;
};

export const handleRegionUpdate = (regionsInfo: BjdItem) => {
  const { setAreaInfo } = useRegionStore.getState();
  setAreaInfo(regionsInfo);
  appToSaveBjdCd(regionsInfo.bjdCd);
};
